import apiService from "@/core/services/apiService";

export type State = { classes: object };
import {Module, VuexModule, Mutation, Action} from "vuex-module-decorators";
import {Actions, Mutations} from "@/store/enums/store.enums";
import {DeliveryLabelsActions, DeliveryLabelsMutation} from "@/modules/deliverylabels/store/enums";
import store from "@/store";

@Module
export default class Store extends VuexModule {
    renderKey = 1;
    listParams = {
        page: 1,
        results: 10,
        search: null,
        sort: [],
        filter: {}
    };
    listCache = [];
    listTotal = 0;

    get getDeliveryLabelsRenderKey() {
        return 'deliveryLabels-' + this.renderKey;
    }

    get getDeliveryLabelsLastListResult() {
        return this.listCache;
    }

    get getDeliveryLabelsLastListTotal() {
        return this.listTotal;
    }

    @Mutation
    [DeliveryLabelsMutation.SET_RENDER_UPDATE]() {
        this.renderKey++;
    }

    @Mutation
    [DeliveryLabelsMutation.SET_LIST_RESULT]({listParams, listTotal, listCache}) {
        this.listParams = listParams;
        this.listCache = listCache;
        this.listTotal = listTotal;
    }

    @Action
    [DeliveryLabelsActions.REFRESH_LIST]() {
        this.context.dispatch(DeliveryLabelsActions.FETCH_LIST, this.listParams);
    }

    @Action
    [DeliveryLabelsActions.FETCH_LIST](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("delivery-labels/list", params).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(DeliveryLabelsMutation.SET_LIST_RESULT, {
                    listParams: params,
                    listTotal: data.results,
                    listCache: data.result
                });
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [DeliveryLabelsActions.GET_ITEM](detailId) {

        return new Promise<void>((resolve, reject) => {

            apiService.get(`delivery-labels/get/${detailId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [DeliveryLabelsActions.CREATE_ITEM](payload) {

        return new Promise((resolve, reject) => {

            const {data} = payload;

            apiService.post('delivery-labels/create', data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(DeliveryLabelsMutation.SET_RENDER_UPDATE);
                this.context.dispatch(DeliveryLabelsActions.REFRESH_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [DeliveryLabelsActions.DELETE_ITEM](deleteId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`delivery-labels/delete/${deleteId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(DeliveryLabelsMutation.SET_RENDER_UPDATE);
                this.context.dispatch(DeliveryLabelsActions.REFRESH_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [DeliveryLabelsActions.DOWNLOAD_LABEL](detailId) {

        return new Promise((resolve, reject) => {

            apiService.get(`delivery-labels/download/${detailId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [DeliveryLabelsActions.FETCH_ORDER_DATA](orderId) {

        return new Promise((resolve, reject) => {

            apiService.get(`delivery-labels/order-data/${orderId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [DeliveryLabelsActions.FETCH_COUNTRIES]() {

        return new Promise((resolve, reject) => {

            apiService.get('delivery-labels/countries').then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

}
